const localStorageAvailable = storageAvailable("localStorage");

export default (() => {
  if (localStorageAvailable) {
    initProductHistoryStorage();
  }

  return store => next => action => {
    if (localStorageAvailable && action.type === "RECEIVE_PRODUCT") {
      const product = {
        ...action.payload.content,
        image: action.payload.options.application[0]?.images[0]?.image_thumb,
        ProductUrl: window.location.href
      };

      addProductToHistory(product);
    }
    let result = next(action);
    return result;
  };
})();

/**
 * Is storage available.
 *
 * This was taken from Mozilla Docs.
 *
 * @tutorial https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
 *
 * @param {string} type
 */
export function storageAvailable(type) {
  try {
    var storage = window[type],
      x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      (e.code === 22 ||
        e.code === 1014 ||
        e.name === "QuotaExceededError" ||
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      storage.length !== 0
    );
  }
}

/**
 * Initialize product history storage.
 *
 *  Set global functions and create an empty array in local storage if it doesn't exist.
 */
export function initProductHistoryStorage() {
  if (
    localStorage.getItem("productViewHistory") !== null &&
    localStorage.getItem("productViewHistory").length > 0 &&
    !Array.isArray(JSON.parse(localStorage.getItem("productViewHistory")))
  ) {
    // if set incorrectly, i.e. a value set, but not an array.
    localStorage.setItem("productViewHistory", "[]");
  } else if (localStorage.getItem("productViewHistory") === null) {
    // if not set.
    localStorage.setItem("productViewHistory", "[]");
  }
}

/**
 * Add unique product view to history.
 *
 * @param {object} product
 */
function addProductToHistory(product) {
  const prevHistory =
    localStorage.getItem("productViewHistory").length > 0
      ? JSON.parse(localStorage.getItem("productViewHistory"))
      : [];

  let newHistory;

  if (Array.isArray(prevHistory) && prevHistory.filter(door => door.hash === product.hash).length > 0) {
    // Product already exists in array.
    newHistory = prevHistory.filter(door => door.hash !== product.hash)
    newHistory.unshift(product)
  } else {
    // Product was not found in prevHistory so add it.
    newHistory = [product].concat(prevHistory);
  }

  if (newHistory.length > 5) {
    newHistory.pop();
  }

  localStorage.setItem("productViewHistory", JSON.stringify(newHistory));
}

/**
 * Get Product View History.
 *
 * @returns {array}
 */
export function getProductViewHistory() {
  return (
    (storageAvailable &&
      localStorage.getItem("productViewHistory") &&
      JSON.parse(localStorage.getItem("productViewHistory"))) ||
    []
  );
}
